var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "meta-5",
  "use": "meta-5-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"meta-5\"><path d=\"M8.267 24.75H14.6V26H7V6h16.467v7.5H22.2V7.25H8.267v17.5zm2.533-15h8.867v3.75h1.267v-5h-11.4v15h5.067v-1.25h-3.8V9.75zm15.2 5V26H15.867V14.75H26zM24.733 16h-7.6v8.75h7.6V16zm-1.267 1.25h-5.067v1.25h5.067v-1.25zm0 2.5h-5.067V21h5.067v-1.25zm-2.533 2.5H18.4v1.25h2.533v-1.25z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol